import { keyframes } from 'styled-components'

export const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to { 
    opacity: 1;
  }
`

export const fadeInAndScaleUp = keyframes`
  from {
    transform: scale(0.7);
    opacity: 0;
  }

  to { 
    opacity: 1;
    transform: scale(1);
  }
`



// WEBPACK FOOTER //
// ./src/Styles/Animations.js